<template>
    <ul :class="classObject" v-if="!!items && !!items.length">
        <nav-item
            v-for="(item, index) in items"
            :key="index"
            :item="item"
        ></nav-item>
    </ul>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            default: null,
            required: true
        },
        sub: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    computed: {
        classObject: function() {
            return {
                nav: true,
                "root-menu": !this.sub,
                "sub-menu": !!this.sub
            };
        }
    }
};
</script>
